module.exports = __webpack_public_path__ + "static/img/head_6.792d26c9.png";